module.exports = __webpack_public_path__ + "static/media/phone-call-24-hours.923fd148.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone-call-24-hours.svg
// module id = 1569
// module chunks = 0